import type { RouteModel } from '@polaris/core/models'
import { useMemo } from 'react'

export function useOneTimeFeesTotal(route?: RouteModel) {
  const oneTimeFeesAbsolute = useMemo(() => {
    return (
      route?.FeeBreakdown.reduce((acc, fee) => {
        if (fee.one_off) {
          return acc + fee.UsdEstimate
        }
        return acc
      }, 0) ?? 0
    )
  }, [route?.FeeBreakdown])

  return oneTimeFeesAbsolute
}
